import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { Modal } from '@gate31/feature/Modal/Modal';

export class ModalFreeDesk extends Modal {
    static readonly cn = new BaseJs.BuildCn('ModalFreeDesk');
}
